import { connect } from 'react-redux'
import SchoolFiles from './school-files'
import { fetchSchoolFiles } from '../../../../stores/school-files/school-files.actions'
import {
  getFetchSchoolFilesRequest,
  getSchoolFiles,
  getServerFilterParams,
  getFetchSchoolFilesRequestInitiator
} from '../../../../stores/school-files/school-files.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => {
  const schoolFiles = getSchoolFiles(state)
  const restrictedFromCreatingAFs =
    me &&
    me.account &&
    me.account.subscription_policy &&
    me.account.subscription_policy.moderation &&
    me.account.subscription_policy.moderation.create_assessment_file &&
    me.account.subscription_policy.moderation.create_assessment_file.restricted
  return {
    restrictedFromCreatingAFs,
    noSchoolFiles: schoolFiles && !schoolFiles.result.length,
    pending:
      !schoolFiles ||
      (getFetchSchoolFilesRequest(state).pending &&
        getFetchSchoolFilesRequestInitiator(state) === 'INITIAL'),
    filterParams: getServerFilterParams(state)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onMount: () => dispatch(fetchSchoolFiles(stateProps.filterParams, 'INITIAL')),
  onUpdate: prevProps => {
    if (prevProps.filterParams !== stateProps.filterParams) {
      const initiator =
        prevProps.filterParams.limit !== stateProps.filterParams.limit
          ? 'LOAD_MORE'
          : 'SEARCH'
      dispatch(fetchSchoolFiles(stateProps.filterParams, initiator))
    }
  }
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(SchoolFiles)
)
